import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { requestApi } from "../../../request-api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as XLSX from "xlsx";
import * as XlsxPopulate from "xlsx-populate/browser/xlsx-populate";
import Dropdown from "../../layouts/dropdown/Dropdown";
import ActDropdown from "../../layouts/dropdown/ActDropdown";
import StatusDropdown from "../../layouts/dropdown/StatusDropdown";
import { API_URL } from "../../../config";
import exportIcon from "../../../assets/image/document-download.png";
import Closed from "../../../assets/image/Closed.svg";
import VectorIcon from "../../../assets/image/Vector.svg";
import { isLocalDateInRange } from "../../../helpers/complianceDashboard";

function Reports() {
  const [report, setReport] = useState([]);
  const [compliance, setCompliance] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isOpen1, setIsOpen1] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedAct, setSelectedAct] = useState([]);
  const [companySearchName, setCompanySearchName] = useState("");
  const [availableActs, setActs] = useState([]);
  const [actSearchName, setActSearchName] = useState("");
  const [companies, setCompanies] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [locationSearchName, setLocationSearchName] = useState("");
  const [locations, setLocations] = useState([]);
  const [filteredReport, setFilteredReport] = useState([]);
  const [selected, setSelected] = useState(" ");
  const [selectedStatus, setSelectedStatus] = useState("Status");
  const [showSearch, setShowSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const dateDropdownRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [sortBy, setSortBy] = useState("none");
  const [format, setFormat] = useState("pdf");
  const [period, setPeriod] = useState("Monthly");
  const [activeFilter, setActiveFilter] = useState("This Month");
  const [selectedSubBranches, setSelectedSubBranches] = useState([]);
  const [availableSubBranches, setAvailableSubBranches] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [showDropdown1, setShowDropdown1] = useState(false);
  const dropdownRef2 = useRef(null);
  // Initialize with current month dates
  const getCurrentMonthDates = () => {
    const now = new Date();
    const start = new Date(now.getFullYear(), now.getMonth(), 1);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return { start, end };
  };

  const { start: defaultStart, end: defaultEnd } = getCurrentMonthDates();
  const [filterDateWise, setFilterDateWise] = useState({
    startDate: defaultStart,
    endDate: defaultEnd,
  });
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredReport.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredReport.length / itemsPerPage);
  const visiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(visiblePages / 2));
  let endPage = startPage + visiblePages - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - visiblePages + 1);
  }
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const [columns, setColumns] = useState([
    { id: "srno", key: "id", label: "Sr No", visible: true },
    { id: "entity", key: "company_name", label: "Entity", visible: true },
    { id: "branch", key: "branch_id", label: "Branch ID", visible: true },
    { id: "legislation", key: "legislation_name", label: "Legislation", visible: true },
    { id: "audited_date", key: "audited_date", label: "Audited Date", visible: true },
    { id: "due_date", key: "due_date", label: "Due Date", visible: true },
    { id: "score", key: "curr", label: "Score", visible: true },
    { id: "date_of_comp", key: "period", label: "Date of Compliance", visible: true },
    { id: "officer", key: "assigned_compliance_officer", label: "Compliance Officer", visible: true },
    { id: "approver", key: "assigned_approver", label: "Approver", visible: true },
    { id: "action", key: "action", label: "Action", visible: true },
  ]);

  const [isOpen4, setIsOpen4] = useState(false);
  const dropdownRef1 = useRef(null);

  const toggleDropdown1 = () => {
    setShowDropdown1((prev) => !prev);
  };

  const handleShowAllColumns = () => {
    setColumns((prev) =>
      prev.map((col) => ({ ...col, visible: true }))
    );
  };

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        dropdownRef1.current &&
        !dropdownRef1.current.contains(event.target)
      ) {
        setIsOpen4(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dateDropdownRef.current &&
        !dateDropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRef2.current &&
        !dropdownRef2.current.contains(event.target)
      ) {
        setShowDropdown1(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const formats = [
    { label: "Pdf", icon: "bi-file-earmark-pdf", value: "pdf" },
    { label: "Excel", icon: "bi-file-earmark-excel", value: "excel" },
  ];
  const periods = ["Monthly", "Quarterly", "Semi-Annually", "Annually"];
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen1) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen1]);

  useEffect(() => {
    fetchReports();
  }, []);

  async function fetchReports() {
    setLoading(true);

    try {
      const { data } = await requestApi("/report/fetch/by-auditor", {
        method: "get",
      });
      setReport(data);

      const _companies = [...new Set(data.map((item) => item.company_name))];
      const _locations = [...new Set(data.map((item) => item.location))];
      const uniqueActs = [
        ...new Set(data.map((item) => item.legislation_name).filter(Boolean)),
      ];
      const _subBranches = [
        ...new Set(data.map((item) => item.sub_branch).filter(Boolean)),
      ];
      setAvailableSubBranches(_subBranches);

      setLocations(_locations);
      setCompanies(_companies);
      setActs(uniqueActs);
    } catch (err) {
      toast.error(err?.data, "Failed to load report data!");
    } finally {
      setLoading(false);
    }
  }

  async function getCopmlianceById(id) {
    setLoading(true);

    try {
      const { data } = await requestApi(`/report/fetch/by-auditor/${id}`, {
        method: "get",
      });

      if (data) {
        setCompliance(data);
        setShowModal(true);
      } else {
        toast.error("No data found.");
      }
    } catch (err) {
      console.log("error", err);
      toast.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    let filtered = [...report];

    // Apply date filter
    if (filterDateWise.startDate && filterDateWise.endDate) {
      filtered = filtered.filter((item) =>
        isLocalDateInRange(item.due_date, filterDateWise.startDate, filterDateWise.endDate)
      );
    }

    if (selectedCompany.length > 0) {
      filtered = filtered.filter((item) =>
        selectedCompany.includes(item.company_name)
      );
    }

    if (selectedLocation.length > 0) {
      filtered = filtered.filter((item) =>
        selectedLocation.includes(item.location)
      );
    }

    if (selectedAct.length > 0) {
      filtered = filtered.filter((item) =>
        selectedAct.includes(item.legislation_name)
      );
    }

    if (selectedSubBranches.length > 0) {
      filtered = filtered.filter((item) =>
        selectedSubBranches.includes(item.sub_branch)
      );
    }

    if (searchValue.trim() !== "") {
      const lowerSearch = searchValue.toLowerCase();
      filtered = filtered.filter(
        (item) =>
          item.company_name.toLowerCase().includes(lowerSearch) ||
          item.branch_id.toLowerCase().includes(lowerSearch)
      );
    }

    if (selectedStatus === "open") {
      filtered = filtered.filter((item) => item.verify_report == 0);
    } else if (selectedStatus === "closed") {
      filtered = filtered.filter((item) => item.verify_report == 1);
    }

    if (sortBy !== "none") {
      filtered = sortReports(filtered, sortBy);
    }

    setFilteredReport(filtered);
    setCurrentPage(1);
  }, [
    report,
    filterDateWise,
    selectedCompany,
    selectedLocation,
    selectedAct,
    searchValue,
    selectedSubBranches,
    selectedStatus,
    sortBy,
  ]);

  useEffect(() => {
    const sorted = sortReports(filteredReport, sortBy);
    setFilteredReport(sorted);
  }, [sortBy]);

  console.log("filtered reports", filteredReport)

  const sortReports = (reports, sortBy) => {
    const criticalityOrder = {
      High: 3,
      Medium: 2,
      Low: 1,
    };

    return [...reports].sort((a, b) => {
      switch (sortBy) {
        case "alphaAsc":
          return a.company_name.localeCompare(b.company_name);
        case "alphaDesc":
          return b.company_name.localeCompare(a.company_name);
        case "dueAsc":
          return new Date(a.due_date || 0) - new Date(b.due_date || 0);
        case "dueDesc":
          return new Date(b.due_date || 0) - new Date(a.due_date || 0);
        case "critLowHigh":
          return (
            (criticalityOrder[a.criticality] || 0) -
            (criticalityOrder[b.criticality] || 0)
          );
        case "critHighLow":
          return (
            (criticalityOrder[b.criticality] || 0) -
            (criticalityOrder[a.criticality] || 0)
          );
        default:
          return 0;
      }
    });
  };

  const toggleCompanySelection = (item) => {
    setSelectedCompany((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleActSelection = (item) => {
    setSelectedAct((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const toggleLocationSelection = (item) => {
    setSelectedLocation((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleQuickFilter = (type) => {
    const now = new Date();
    let start = new Date();
    let end = new Date();

    switch (type) {
      case "This Month":
        start = new Date(now.getFullYear(), now.getMonth(), 1);
        end = new Date(now.getFullYear(), now.getMonth() + 1, 0);
        break;
      case "Today":
        break;
      case "Yesterday":
        start.setDate(now.getDate() - 1);
        end.setDate(now.getDate() - 1);
        break;
      case "Last 7 days":
        start.setDate(now.getDate() - 6);
        break;
      case "Last 30 days":
        start.setDate(now.getDate() - 29);
        break;
      case "Manual":
        setActiveFilter("Manual");
        return;
      default:
        return;
    }

    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);

    setFilterDateWise({ startDate: start, endDate: end });
    setActiveFilter(type);
    setIsOpen(false); // Close dropdown when quick filter is selected

    // applyDateFilter({ startDate: start, endDate: end });
  };

  const applyDateFilter = (dates = filterDateWise) => {
    const dateFiltered = report.filter((item) =>
      isLocalDateInRange(item.due_date, dates.startDate, dates.endDate)
    );

    const finalFiltered =
      selectedCompany.length > 0
        ? dateFiltered.filter((item) =>
          selectedCompany.includes(item.company_name)
        )
        : dateFiltered;

    setIsOpen(!isOpen);
    setFilteredReport(finalFiltered);
  };

  const toggleDropdown = () => setShowDropdown(!showDropdown);

  const exportReport = (data, format, startDate, endDate) => {
    const now = new Date();
    //let startDate = null;

    // switch (period) {
    //   case "Monthly":
    //     startDate = new Date(now.getFullYear(), now.getMonth(), 1);
    //     break;
    //   case "Quarterly":
    //     startDate = new Date(now.getFullYear(), Math.floor(now.getMonth() / 3) * 3, 1);
    //     break;
    //   case "Semi-Annually":
    //     startDate = new Date(now.getFullYear(), now.getMonth() < 6 ? 0 : 6, 1);
    //     break;
    //   case "Annually":
    //     startDate = new Date(now.getFullYear(), 0, 1);
    //     break;
    //   default:
    //     startDate = null;
    // }

    let exportData = [...data];

    if (startDate && endDate) {
      exportData = exportData.filter((item) =>
        isLocalDateInRange(item.due_date, startDate, endDate)
      );
    }

    if (selectedSubBranches.length > 0) {
      exportData = exportData.filter((item) =>
        selectedSubBranches.includes(item.sub_branch)
      );
    }

    if (exportData.length === 0) {
      toast.error("No data found for the selected period.");
      return;
    }

    // Custom headers mapping
    const headersMap = {
      sr_no: "ID",
      company_name: "Entity",
      branch_id: "Branch",
      legislation_name: "Legislation",
      location: "Location",
      audited_date: "Audited Date",
      due_date: "Due Date",
      score: "Score",
      compd: "Compliance Description",
      curr: "Current Status",
      sub_branch: "Sub Branch",
      assigned_compliance_officer: "Compliance Officer",
      assigned_approver: "Approver",
      // status: "Status",
      verify_report: "Verified",
      criticality: "Criticality",
      created_at: "Created At"
    };

    const formatDate = (iso) => {
      if (!iso) return "";
      const d = new Date(iso);
      return d.toLocaleDateString("en-GB").replace(/\//g, "-");
    };

    const formattedData = exportData.map((item, index) => {
      const calculateScore = (status) => {
        switch (status) {
          case "Compiled":
            return "1";
          case "Partial Compiled":
            return "0.5";
          case "Not Complied":
            return "0";
          case "Not Applicable":
            return "0";
          default:
            return "-";
        }
      };

      return {
        "Sr No": index + 1,
        "Entity": item.company_name,
        "Branch": item.branch_id,
        "Legislation": item.legislation_name,
        "Location": item.location,
        "Audited Date": formatDate(item.audited_date),
        "Due Date": formatDate(item.due_date),
        "Score": calculateScore(item.curr),
        "Compliance Description": item.compd,
        "Current Status": item.curr,
        "Sub Branch": item.sub_branch,
        "Compliance Officer": item.assigned_compliance_officer,
        "Approver": item.assigned_approver,
        "Summary of Observation": item.summary_of_observation,
        "Management Remarks": item.management_remark,
        "Additional Information": item.additional_information,
        "Knowledge Bank": item.knowledge_bank,
        "Date of Compliance": formatDate(item.period),
        // "Status": item.status ? "Completed" : "Pending",
        "Verified": item.verify_report ? "Yes" : "No",
        "Criticality": item.criticality,
        "Created At": formatDate(item.created_at)
      };
    });

    if (format === "excel") {
      const displayHeaders = Object.keys(formattedData[0] || {});

      const uniqueCompanies = [
        ...new Set(
          formattedData
            .map((item) => item["Entity"] || item.companyName || item.company_name)
            .filter(Boolean)
        ),
      ];
      let companyNameText = "";
      if (uniqueCompanies.length > 0) {
        companyNameText = uniqueCompanies.join(", ");
      } else if (
        typeof selectedCompany !== "undefined" &&
        selectedCompany &&
        selectedCompany.length > 0
      ) {
        companyNameText = Array.isArray(selectedCompany)
          ? selectedCompany.join(", ")
          : selectedCompany;
      } else {
        companyNameText = "Company Name";
      }

      const uniqueLocations = [
        ...new Set(
          formattedData
            .map((item) => item["Location"] || item.location)
            .filter(Boolean)
        ),
      ];
      let locationText = "";
      if (uniqueLocations.length > 0) {
        locationText = uniqueLocations.join(", ");
      } else if (
        typeof selectedLocation !== "undefined" &&
        selectedLocation &&
        selectedLocation.length > 0
      ) {
        locationText = Array.isArray(selectedLocation)
          ? selectedLocation.join(", ")
          : selectedLocation;
      } else {
        locationText = "All Locations";
      }

      let dateRangeText = "";
      if (
        typeof filterDateWise !== "undefined" &&
        filterDateWise &&
        filterDateWise.startDate &&
        filterDateWise.endDate
      ) {
        dateRangeText = `${formatDate(filterDateWise.startDate)} to ${formatDate(filterDateWise.endDate)}`;
      } else if (period) {
        dateRangeText = period;
      } else {
        dateRangeText = "All";
      }

      const getColumnLetter = (colIndex) => {
        let temp,
          letter = "";
        while (colIndex > 0) {
          temp = (colIndex - 1) % 26;
          letter = String.fromCharCode(65 + temp) + letter;
          colIndex = (colIndex - temp - 1) / 26;
        }
        return letter;
      };

      const totalCols = displayHeaders.length;
      const lastColLetter = getColumnLetter(totalCols);
      const totalRows = 4 + formattedData.length;

      const worksheet = XLSX.utils.json_to_sheet(formattedData, {
        origin: "A4",
      });

      const colWidths = displayHeaders.map((header) => ({
        wch: Math.max(String(header).length + 5, 18),
      }));
      worksheet["!cols"] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

      XlsxPopulate.fromDataAsync(wbout)
        .then((wb) => {
          const sheet = wb.sheet(0);

          // 1. Row 1: Company Name (Left Aligned)
          const companyRange = sheet.range(`A1:${lastColLetter}1`);
          companyRange.merged(true);
          sheet.cell("A1").value(`Company Name: ${companyNameText}`);
          companyRange.style({
            bold: true,
            fontSize: 14,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 2. Row 2: Location (Left Aligned)
          const locationRange = sheet.range(`A2:${lastColLetter}2`);
          locationRange.merged(true);
          sheet.cell("A2").value(`Location: ${locationText}`);
          locationRange.style({
            bold: true,
            fontSize: 11,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 3. Row 3: Period (Left Aligned)
          const dateRange = sheet.range(`A3:${lastColLetter}3`);
          dateRange.merged(true);
          sheet.cell("A3").value(`Period: ${dateRangeText}`);
          dateRange.style({
            bold: true,
            fontSize: 11,
            wrapText: true,
            horizontalAlignment: "left",
            verticalAlignment: "center",
            fill: "F2F2F2",
            border: true,
          });

          // 4. Headings (Row 4): bold, larger text size, text wrapping, highlighted background, borders
          sheet.range(`A4:${lastColLetter}4`).style({
            bold: true,
            fontSize: 12,
            wrapText: true,
            horizontalAlignment: "center",
            verticalAlignment: "center",
            fill: "D9E1F2",
            border: true,
          });

          // 5. Data Contents (Row 5..totalRows): text wrapping, vertical alignment, borders
          if (totalRows >= 5) {
            sheet.range(`A5:${lastColLetter}${totalRows}`).style({
              wrapText: true,
              fontSize: 10,
              verticalAlignment: "center",
              border: true,
            });
          }

          return wb.outputAsync();
        })
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const a = document.createElement("a");
          a.href = url;
          a.download = `Compliance_Report_${period}.xlsx`;
          a.click();
          window.URL.revokeObjectURL(url);
        });
    } else if (format === "pdf") {
      const newWindow = window.open();
      if (!newWindow) return;

      const headers = Object.keys(formattedData[0]);
      const rows = formattedData.map(item => {
        return `<tr>${headers.map(h => `<td>${item[h] || ""}</td>`).join("")}</tr>`;
      });

      const htmlContent = `
      <html>
        <head>
          <title>Compliance Report</title>
          <style>
            body { font-family: Arial, sans-serif; }
            h2 { text-align: center; margin-bottom: 20px; }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 10px;
              table-layout: fixed;
              word-wrap: break-word;
            }
            th, td {
              border: 1px solid #000;
              padding: 4px;
              text-align: left;
            }
            th {
              background-color: #f2f2f2;
            }
              @media print {
  body {
    zoom: 50%; /* scale down for printing */
  }
}

          </style>
        </head>
        <body>
          <h2>Compliance Report - ${period}</h2>
          <table>
            <thead>
              <tr>${headers.map(h => `<th>${h}</th>`).join("")}</tr>
            </thead>
            <tbody>${rows.join("")}</tbody>
          </table>
        </body>
      </html>
    `;

      newWindow.document.write(htmlContent);
      newWindow.document.close();
      newWindow.print();
    }
  };


  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const isImageFile = (fileName) => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp"];
    const extension = fileName.split(".").pop().toLowerCase();
    return imageExtensions.includes(extension);
  };

  const cleanFileName = (filePath) => {
    return filePath.split("/").pop();
  };

  const getFileType = (fileName) => {
    const extension = fileName.split(".").pop().toUpperCase();
    return `${extension} File`;
  };

  const renderFileIcon = (fileName) => {
    const extension = fileName.split(".").pop().toLowerCase();
    const icons = {
      pdf: "https://cdn-icons-png.flaticon.com/512/337/337946.png",
      doc: "https://cdn-icons-png.flaticon.com/512/888/888879.png",
      xls: "https://cdn-icons-png.flaticon.com/512/888/888879.png",
      default: "https://cdn-icons-png.flaticon.com/512/833/833524.png",
    };
    const icon = icons[extension] || icons.default;
    return (
      <img
        src={icon}
        alt="File icon"
        style={{ width: "32px", height: "32px", marginRight: "8px" }}
      />
    );
  };

  if (loading) {
    return (
      <div className="loader-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <section className="lyt-section typ-min-height p-5">
      <div className=" ">
        <div className="">
          <div className="d-flex justify-content-between">
            <div className="d-flex w-100 justify-content-between">
              <div className="d-flex gap-3">


                <div
                  style={{ position: "relative", display: "flex", gap: "8px" }}
                >
                  <div style={{ position: "relative" }}>
                    <button
                      className="btn  shadow-sm d-flex align-items-center justify-content-center fh"
                      onClick={() => {
                        // setShowSearch(!showSearch);
                        setShowSearch(!showSearch);
                        setSearchValue("");
                      }}
                      style={{
                        minWidth: "40px",
                        // height: "36px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        backgroundColor: "#fff",
                      }}
                    >
                      {showSearch ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="black"
                          viewBox="0 0 16 16"
                        >
                          <path d="M4.646 4.646a.5.5 0 011.415 0L8 6.586l1.939-1.94a.5.5 0 01.707.708L8.707 7.293l1.939 1.94a.5.5 0 01-.707.707L8 8.001 6.061 9.94a.5.5 0 11-.707-.707L7.293 8 5.354 6.061a.5.5 0 010-.707z" />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="black"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0
            1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zm-5.24 1.106a5 5 0 1 1
            0-10 5 5 0 0 1 0 10z"
                          />
                        </svg>
                      )}
                    </button>

                    {showSearch && (
                      <input
                        type="text"
                        placeholder="Search company or branch"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        style={{
                          position: "absolute",
                          top: "45px",
                          left: 0,
                          width: "260px",
                          padding: "8px 10px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                          zIndex: 10,
                        }}
                      />
                    )}
                  </div>
                </div>

                <Dropdown
                  label="Select Company Name"
                  options={companies}
                  selectedItems={selectedCompany}
                  setSelectedItems={setSelectedCompany}
                />

                <Dropdown
                  label="Sub Branch"
                  options={availableSubBranches}
                  selectedItems={selectedSubBranches}
                  setSelectedItems={setSelectedSubBranches}
                />
                <ActDropdown
                  label="Select Acts"
                  availableActs={availableActs}
                  selectedActs={selectedAct}
                  setSelectedActs={setSelectedAct}
                />
                <div className=""></div>
                <Dropdown
                  label="Select Location"
                  options={locations}
                  selectedItems={selectedLocation}
                  setSelectedItems={setSelectedLocation}
                />

                <div className="position-relative d-inline-block" ref={dateDropdownRef}>
                  <button
                    className="btn bg-white border border-secondary-subtle d-flex align-items-center gap-2 w-100 py-1.5 px-2"
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    aria-expanded={isOpen}
                  >
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/747/747310.png"
                      alt="Calendar Icon"
                      width="14"
                      height="14"
                    />
                    <span style={{ fontSize: "12px" }}>
                      {filterDateWise.startDate?.toLocaleDateString("en-GB")} -{" "}
                      {filterDateWise.endDate?.toLocaleDateString("en-GB")}
                    </span>
                  </button>

                  {isOpen && (
                    <div
                      className="position-absolute mt-2 bg-white border shadow p-3"
                      style={{
                        zIndex: 1000,
                        width: "718px",
                        maxWidth: "95vw",
                        right: 0,
                        overflow: "hidden",
                      }}
                    >
                      <div className="row">
                        <div className="col-md-3">
                          <ul className="list-group fs-12">
                            {[
                              "This Month",
                              "Today",
                              "Yesterday",
                              "Last 7 days",
                              "Last 30 days",
                              "Manual",
                            ].map((label) => (
                              <li
                                key={label}
                                className={`list-group-item ${activeFilter === label ? "bg-light rounded" : ""
                                  }`}
                                style={{ border: "none", cursor: "pointer" }}
                                onClick={() => handleQuickFilter(label)}
                              >
                                {label}
                              </li>
                            ))}
                          </ul>
                        </div>

                        {activeFilter === "Manual" && (
                        <div className="col-md-9 border-start">
                          <div className="row">
                            <div className="col-md-6">
                              <DatePicker
                                selected={filterDateWise.startDate}
                                onChange={(date) =>
                                  setFilterDateWise((prev) => ({
                                    ...prev,
                                    startDate: date,
                                  }))
                                }
                                inline
                              />
                            </div>
                            <div className="col-md-6">
                              <DatePicker
                                selected={filterDateWise.endDate}
                                onChange={(date) =>
                                  setFilterDateWise((prev) => ({
                                    ...prev,
                                    endDate: date,
                                  }))
                                }
                                inline
                              />
                            </div>
                          </div>

                          <div className="mt-3 d-flex justify-content-between align-items-center">
                            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                              <span
                                style={{
                                  backgroundColor: "#343a40",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                {filterDateWise.startDate?.toLocaleDateString("en-GB")}
                              </span>

                              <span style={{ fontSize: "16px" }}>→</span>

                              <span
                                style={{
                                  backgroundColor: "#343a40",
                                  color: "#fff",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                }}
                              >
                                {filterDateWise.endDate?.toLocaleDateString("en-GB")}
                              </span>
                            </div>

                            <button
                              className="btn btn-dark fs-12"
                              onClick={() => applyDateFilter()}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>


                <div className="dropdown">
                  <button
                    className="btn bg-white border  py-1 px-2   border-secondary-subtle d-flex align-items-center justify-content-center shadow-sm gap-2 fh "
                    data-bs-toggle="dropdown"
                  >
                    <span className="text-dark">
                      {selectedStatus.charAt(0).toUpperCase() +
                        selectedStatus.slice(1) || "Select Status"}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="black"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fillRule="evenodd"
                        d="M1.5 5.5a.5.5 0 0 1 .854-.354l5.646 5.646 5.646-5.646a.5.5 0 1 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1-.146-.354"
                      />
                    </svg>
                  </button>

                  <div
                    className="dropdown-menu p-2 shadow"
                    style={{ width: "200px" }}
                  >
                    <div style={{ maxHeight: "250px", overflowY: "auto" }}>
                      <div className="list-group border-0">
                        {["open", "closed"].map((status, index) => (
                          <button
                            key={index}
                            className="list-group-item text-muted border-bottom border-0 d-flex align-items-center"
                            style={{ cursor: "pointer" }}
                            onClick={() => setSelectedStatus(status)}
                          >
                            {status.charAt(0).toUpperCase() + status.slice(1)}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex gap-4">
                <div className="">
                  <button
                    class="btn bg-white border border-secondary-subtle rounded d-flex align-items-center justify-content-center p-2 shadow-sm py-1.5 fh"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path d="M3 3h10v1H3V3zm0 3h7v1H3V6zm0 3h4v1H3V9zm8 2h3v-3h1v3h3l-3.5 3.5L11 11z" />
                    </svg>
                  </button>
                  <ul
                    className="dropdown-menu shadow-sm"
                    style={{ minWidth: "180px", fontSize: "12px" }}
                  >
                    <li>
                      <span
                        onClick={() => setSortBy("alphaDesc")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Reverse Alphabetical{" "}
                        <small className="text-muted fs-12">Z–A</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("alphaAsc")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Alphabetical <small className="text-muted fs-12">A–Z</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("dueAsc")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Due Date - Ascending{" "}
                        <small className="text-muted fs-12">Oldest</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("dueDesc")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Due Date - Descending{" "}
                        <small className="text-muted fs-12">Newest</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("critHighLow")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Criticality{" "}
                        <small className="text-danger fs-12">High–Low</small>
                      </span>
                    </li>
                    <li>
                      <span
                        onClick={() => setSortBy("critLowHigh")}
                        className="dropdown-item d-flex justify-content-between align-items-center fs-12"
                        style={{ cursor: "pointer" }}
                      >
                        Criticality{" "}
                        <small className="text-success fs-12">Low–High</small>
                      </span>
                    </li>
                  </ul>
                </div>

                <div className="position-relative" ref={dropdownRef1}>
                  <button
                    className="btn bg-white border border-secondary-subtle d-flex align-items-center justify-content-center p-2 shadow-sm py-1.5  fh "
                    onClick={() => setIsOpen4(!isOpen4)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 16 16"
                      fill="currentColor"
                    >
                      <path d="M4 3h2v10H4V3zm3 0h2v10H7V3zm3 0h2v10h-2V3z" />
                    </svg>
                  </button>

                  {isOpen4 && (
                    <div
                      className="dropdown-menu show p-2 shadow-sm bg-white"
                      style={{
                        position: "absolute",
                        top: "100%",
                        right: -110,
                        width: "250px",
                        borderRadius: "5px",
                        fontSize: "12px",
                        zIndex: 9999,
                        marginTop: "2px",

                      }}
                    >
                      <div className="fw-bold text-muted p-2 bg-light fs-12">
                        Default View
                      </div>

                      <div className="d-flex justify-content-between py-1 border-bottom bg-light">
                        <span className="fw-bold fs-12">Hidden</span>
                        <span
                          className="text-primary fs-12"
                          style={{ cursor: "pointer" }}
                          onMouseDown={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleShowAllColumns();
                          }}
                        >
                          Show all
                        </span>
                      </div>

                      <ul className="list-unstyled px-2 fs-12">
                        {columns.map((col, index) => (
                          <li key={col.id} className="d-flex align-items-center py-1">
                            <input
                              type="checkbox"
                              className="me-2"
                              checked={col.visible}
                              onChange={() =>
                                setColumns(
                                  columns.map((c, i) =>
                                    i === index ? { ...c, visible: !c.visible } : c
                                  )
                                )
                              }
                            />
                            {col.label}
                          </li>
                        ))}
                      </ul>




                    </div>
                  )}
                </div>

                <div className="dropdown" ref={dropdownRef2}>
                  <button
                    className="btn btn-outline-dark d-flex align-items-center gap-2 fh"
                    onClick={toggleDropdown1}
                    style={{
                      backgroundColor: "#fff",
                      border: "1px solid #E4E4E7",
                      color: "#1F1F23",
                      fontWeight: 500,
                      padding: "6px 6px",
                    }}
                  >
                    <img
                      src={exportIcon}
                      alt="Export Icon"
                      width="16"
                      height="16"
                    />
                    Export
                  </button>
                  {showDropdown1 && (
                    <div
                      className="card shadow-sm position-absolute mt-2 end-0"
                      style={{
                        width: "200px",
                        zIndex: 9999,
                        transform: "translateX(10px)",
                      }}
                    >
                      <div>
                        <label className="bg-light py-1 px-2 w-100 fs-12">
                          Format
                        </label>
                        <div className="btn-group w-100 mt-2 px-2">
                          {formats.map((f) => (
                            <button
                              key={f.value}
                              className={`btn ${format === f.value
                                ? "btn-dark"
                                : "btn-outline-dark"
                                }`}
                              onClick={() => setFormat(f.value)}
                            >
                              <i className={`bi ${f.icon}`}></i> {f.label}
                            </button>
                          ))}
                        </div>
                      </div>

                      <div className="d-flex justify-content-end">
                        <button
                          className="btn btn-dark w-50 mt-3 mb-2 mx-2 fs-12"
                          onClick={() =>
                            exportReport(filteredReport, format)
                          }
                        >
                          Export
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-4">
        <div className="">
          <div className="card-body p-0">
            <div className="table-scroll">
              <table className="table table-hover align-middle mt-0 rounded vertical-border">
                <thead className=" bg-light text-nowrap fs-12 table-color">
                  <tr>

                    {columns.map(
                      (col) => col.visible && <th key={col.id}>{col.label}</th>
                    )}
                  </tr>
                </thead>

                <tbody className="fs-12 table-color">
                  {Array.isArray(currentItems) && currentItems.length > 0 ? (
                    currentItems.map((key, i) => (
                      <tr key={i}>


                        {columns.map(
                          (col) =>
                            col.visible && (
                              <td key={col.id}>
                                {/* Special render cases */}
                                {col.id === "srno" ? (
                                  i + 1
                                ) : col.id === "branch" ? (
                                  <span style={{ color: "#0d6efd" }}>
                                    {key?.branch_id || "NA"}
                                  </span>
                                ) : col.id === "audited_date" ? (
                                  key?.audited_date
                                    ? new Date(key?.audited_date)
                                      .toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })
                                      .replace(/ (\w{3}) /, " $1, ")
                                    : "NA"
                                ) : col.id === "due_date" ? (
                                  key?.due_date ? (() => {
                                    const dueDate = new Date(key.due_date);
                                    const today = new Date();
                                    const diffTime = dueDate - today;
                                    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                                    if (diffDays < 0) diffDays = 0;

                                    const formattedDate = dueDate
                                      .toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })
                                      .replace(/ (\w{3}) /, " $1, ");

                                    let blinkClass = "blink ";
                                    blinkClass += diffDays > 0 ? "text-green-600" : "text-red-600";

                                    return (
                                      <span>
                                        {formattedDate}{" "}
                                        <span className={blinkClass}>
                                          ({diffDays} days to go)
                                        </span>
                                      </span>
                                    );
                                  })() : "NA"
                                ) : col.id === "score" ? (
                                  key?.curr === "Complied"
                                    ? "1"
                                    : key?.curr === "Not Complied"
                                      ? "0"
                                      : key?.curr === "Partial Complied"
                                        ? "0.5"
                                        : key?.curr === "Not Applicable"
                                          ? "0"
                                          : "-"
                                ) : col.id === "date_of_comp" ? (
                                  key?.period
                                    ? new Date(key.period)
                                      .toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "short",
                                        year: "numeric",
                                      })
                                      .replace(/ (\w{3}) /, " $1, ")
                                    : "NA"
                                ) : col.id === "action" ? (
                                  <button
                                    className="closeandopen-btn"
                                    onClick={() => getCopmlianceById(Number(key.id))}
                                    style={{
                                      color:
                                        key.status === 0
                                          ? "rgba(255, 140, 0, 1)"
                                          : "rgba(255, 140, 0, 1)"
                                    }}
                                  >
                                    <img
                                      src={key.status == 0 ? VectorIcon : Closed}
                                      alt={key.status == 0 ? "open" : "closed"}
                                      style={{ width: 16, height: 16 }}
                                    />
                                    {key.verify_report == 0 ? "Open" : "Closed"}
                                  </button>

                                ) : (
                                  key[col.key] ?? "NA"
                                )}
                              </td>
                            )
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="12"
                        style={{
                          textAlign: "center",
                          padding: "12px",
                          color: "#6c757d",
                        }}
                      >
                        No records found.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              {(showModal || loading) && (
                <div
                  className="modal fade show d-block"
                  tabIndex="-1"
                  role="dialog"
                  style={{
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <div
                    className="modal-dialog modal-dialog-centered"
                    role="document"
                    style={{ maxWidth: "800px", width: "100%" }}
                  >
                    <div
                      className="modal-content p-4"
                      style={{ borderRadius: "12px" }}
                    >
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h5 className="modal-title fs-12">VERIFY REPORT</h5>
                        <button
                          type="button"
                          className="btn-close"
                          onClick={() => setShowModal(false)}
                        />
                      </div>
                      <form>
                        <div>
                          <h4 className="fs-12">
                            Procedure for nomination{" "}
                            <span
                              style={{
                                display: "inline-block",
                                padding: "2px 8px",
                                backgroundColor: "#f3f4f6",
                                color: "#1f2937",
                                borderRadius: "12px",
                                fontSize: "12px",
                                fontWeight: "500",
                                boxShadow: "0 0 0 1px #d1d5db",
                              }}
                            >
                              {compliance?.provision}
                            </span>
                          </h4>
                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <strong style={{ fontSize: "12px" }}>
                              {" "}
                              Compliance Description:{" "}
                            </strong>
                            {compliance?.compliance || "NA"}
                          </p>
                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <strong style={{ fontSize: "12px" }}>
                              {" "}
                              Penalty Type:{" "}
                            </strong>
                            {compliance?.penalty_type || "NA"}
                          </p>
                          <p
                            className="text-muted"
                            style={{ fontSize: "12px" }}
                          >
                            {" "}
                            <strong style={{ fontSize: "12px" }}>
                              {" "}
                              Penalty Description :{" "}
                            </strong>
                            {compliance?.penalty_description || "NA"}
                          </p>
                          <strong className="fs-12">Select Status</strong>
                          <br />
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              backgroundColor:
                                compliance?.current_compliance_status === "Complied"
                                  ? "#d1fae5"
                                  : compliance?.current_compliance_status === "Partial Complied"
                                    ? "#fef9c3"
                                    : compliance?.current_compliance_status === "Not Complied"
                                      ? "#fee2e2"
                                      : compliance?.current_compliance_status === "Not Applicable"
                                        ? "#e0f2fe"
                                        : "#ffe8dc", // fallback (light orange)
                              color:
                                compliance?.current_compliance_status === "Complied"
                                  ? "#065f46"
                                  : compliance?.current_compliance_status === "Partial Complied"
                                    ? "#92400e"
                                    : compliance?.current_compliance_status === "Not Complied"
                                      ? "#991b1b"
                                      : compliance?.current_compliance_status === "Not Applicable"
                                        ? "#1e40af"
                                        : "#9a3412", // fallback (dark orange)
                              border:
                                compliance?.current_compliance_status === "Complied"
                                  ? "1px solid #10b981"
                                  : compliance?.current_compliance_status === "Partial Complied"
                                    ? "1px solid #facc15"
                                    : compliance?.current_compliance_status === "Not Complied"
                                      ? "1px solid #ef4444"
                                      : compliance?.current_compliance_status === "Not Applicable"
                                        ? "1px solid #3b82f6"
                                        : "1px solid #f9964bff", // fallback (orange)
                              borderRadius: "4px",
                              padding: "4px 12px",
                              fontSize: "12px",
                              fontWeight: "500",
                            }}
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: "8px",
                                height: "8px",
                                backgroundColor:
                                  compliance?.current_compliance_status === "Complied"
                                    ? "#10b981"
                                    : compliance?.current_compliance_status === "Partial Complied"
                                      ? "#facc15"
                                      : compliance?.current_compliance_status === "Not Complied"
                                        ? "#ef4444"
                                        : compliance?.current_compliance_status === "Not Applicable"
                                          ? "#3b82f6"
                                          : "#f9964bff", // fallback (orange)
                                borderRadius: "50%",
                                marginRight: "8px",
                              }}
                            ></span>
                            {compliance?.current_compliance_status || "NA"}
                          </div>

                          <div className="mb-3">
                            <label className="form-label fw-semibold fs-12">
                              Attached Proof
                            </label>
                            {compliance?.proof_file &&
                              compliance.proof_file !== "" ? (
                              <div
                                className="border p-2 rounded bg-light mt-2"
                                style={{ fontSize: "12px", width: "300px" }}
                              >
                                {!isImageFile(compliance.proof_file) ? (
                                  <div className="d-flex justify-content-between align-items-center mb-2">
                                    <div className="d-flex align-items-center">
                                      {renderFileIcon(compliance.proof_file)}
                                      <div className="ml-2">
                                        <div>
                                          <strong>
                                            {cleanFileName(
                                              compliance.proof_file
                                            )}
                                          </strong>
                                        </div>
                                        <div
                                          style={{
                                            fontSize: "10px",
                                            color: "#888",
                                          }}
                                        >
                                          {getFileType(compliance.proof_file)}
                                        </div>
                                      </div>
                                    </div>
                                    <a
                                      href={`${API_URL}/${compliance.proof_file}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn btn-sm btn-dark"
                                      style={{ fontSize: "10px" }}
                                    >
                                      View
                                    </a>
                                  </div>
                                ) : (
                                  <img
                                    src={`${API_URL}/${compliance.proof_file}`}
                                    alt="Proof File"
                                    style={{
                                      width: "100%",
                                      maxHeight: "150px",
                                      objectFit: "contain",
                                      borderRadius: "8px",
                                      backgroundColor: "#f0f0f0",
                                    }}
                                    className="mt-2"
                                  />
                                )}
                              </div>
                            ) : (
                              <div className="fw-normal text-dark">NA</div>
                            )}
                          </div>
                          <div>
                            <label className="text-xs font-medium">
                              Attached Proof Link
                            </label>
                          </div>
                          <a
                            href={encodeURI(compliance?.proofs_link)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {compliance?.proofs_link || "NA"}
                          </a>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "16px",
                              paddingTop: "16px",
                            }}
                          >
                            <div
                              style={{
                                flex: "1 1 45%",
                                minWidth: "280px",
                              }}
                            >
                              <h4
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#1f2937",
                                  marginBottom: "4px",
                                }}
                              >
                                Compliancer Officer Comment
                              </h4>
                              <p
                                style={{
                                  fontSize: "14px",
                                  color: "#4b5563",
                                }}
                              >
                                {compliance?.comment_of_officer || "NA"}
                              </p>
                            </div>
                            <div
                              style={{
                                flex: "1 1 45%",
                                minWidth: "280px",
                              }}
                            >
                              <h4
                                style={{
                                  fontSize: "12px",
                                  fontWeight: "600",
                                  color: "#1f2937",
                                  marginBottom: "4px",
                                }}
                              >
                                Compliancer Officer Description
                              </h4>
                              <p
                                style={{
                                  fontSize: "12px",
                                  color: "#4b5563",
                                }}
                              >
                                {compliance?.compliance_description || "NA"}
                              </p>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <select
            className="form-select form-select-sm w-auto"
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
          >
            {[10, 20, 30, 50].map((size) => (
              <option key={size} value={size} className="fs-12">
                {size} per page
              </option>
            ))}
          </select>
        </div>
        <nav>
          <ul className="pagination mb-0 d-flex align-items-center gap-2">
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link text-dark border-0 bg-transparent fs-12"
                onClick={handlePrevious}
              >
                Previous
              </button>
            </li>
            {startPage > 1 && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}
            {pageNumbers.map((pageNum) => (
              <li
                key={pageNum}
                className={`page-item ${currentPage === pageNum ? "active" : ""
                  }`}
              >
                <button
                  className={`page-link d-flex align-items-center justify-content-center fw-bold rounded-circle circle ${pageNum === currentPage
                    ? "bg-dark text-white"
                    : "text-dark bg-transparent"
                    } border-0`}

                  onClick={() => handlePageChange(pageNum)}
                >
                  {pageNum}
                </button>
              </li>
            ))}
            {endPage < totalPages && (
              <li className="page-item disabled">
                <span className="page-link border-0 bg-transparent">...</span>
              </li>
            )}

            <li
              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                }`}
            >
              <button
                className="page-link text-dark border-0 bg-transparent"
                onClick={handleNext}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </section>
  );
}
export default Reports;
